import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=7840654b&scoped=true&"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=7840654b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840654b",
  null
  
)

export default component.exports